import React, { Component } from 'react';

import Blank from '../../../hoc/Blank/Blank';
import Button from '../../UI/Button/Button';

class AddOrderErrorModal extends Component {
    render () {
        return (
            <Blank>
                <h3>Add Order Error</h3>
                <p>Please Check over the form.
                <br />At a minimum you need:
                </p>
                <ul>
                    <li>Name</li>
                    <li>Address</li>
                    <li>City and Zip</li>
                    <li>Some Mulch</li>
                    <li>Delivery Type</li>
                    <li>Payment Status</li>
                </ul>
                <Button btnType="Danger" clicked={this.props.modalClosed}>CANCEL</Button>
            </Blank>
        );
    }
}

export default AddOrderErrorModal;


// WEBPACK FOOTER //
// ./src/components/ErrorModals/AddOrderErrorModal/AddOrderErrorModal.js